import {
  ClientEmployeeFragment,
  useClientEmployeeQuery,
  useUpdateClientEmployeeMutation,
} from "@graphql/client-employees/clientEmployees.g";

import {
  ClientEmployeeForm,
  ClientEmployeeFormValues,
} from "@components/Forms/ClientEmployeeForm/ClientEmployeeForm";

type Props = {
  clientId: string;
  clientEmployeeId: string;
  onUpdateClientEmployeeSuccess?: (
    data: ClientEmployeeFragment,
  ) => Promise<void> | void;
};

export const UpdateClientEmployeeForm = ({
  clientId,
  clientEmployeeId,
  onUpdateClientEmployeeSuccess,
}: Props) => {
  const clientEmployeeQuery = useClientEmployeeQuery({
    clientId,
    clientEmployeeId,
  });
  const updateClientEmployeeMutation = useUpdateClientEmployeeMutation();
  const updateClientEmployee = updateClientEmployeeMutation.mutateAsync;

  const clientEmployee = clientEmployeeQuery.data?.clientEmployee ?? undefined;

  const onSubmit = async (values: ClientEmployeeFormValues) => {
    const data = await updateClientEmployee({
      input: {
        id: clientEmployeeId,
        clientId,
        ...values,
      },
    });

    const clientEmployee = data?.updateClientEmployee?.employee;

    if (!clientEmployee) return;

    await onUpdateClientEmployeeSuccess?.(clientEmployee);
  };

  return (
    <ClientEmployeeForm
      onSubmit={onSubmit}
      values={clientEmployee}
      submitText="Update"
    />
  );
};
